/* @refresh reload */
import { render } from "solid-js/web";
import { App } from "./App";
import { fetchMe } from "./features/auth/api";
import { LoginScreen } from "./features/auth/LoginScreen";
import { initSettings } from "./shared/settings/cache";
// Side-effect import: when the URL carries ?perf=1, this installs the
// window.__perf instrumentation hook that the Playwright harness reads.
// No-op when the flag isn't set.
import "./shared/perf";
import "./shared/styles/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root element not found in index.html");

// Auth gate runs before the app shell is touched. /api/me returns 401
// when the user isn't signed in (and 200 with {authDisabled: true}
// when the backend is configured without auth — dev / LOCAL_ONLY).
// Settings init only fires on the authenticated branch so we don't
// hit /api/settings while unauthenticated and pollute the UI with a
// "settings failed to load" warning right before the login screen.
const me = await fetchMe();
if (!me.authenticated) {
  render(() => <LoginScreen />, root);
} else {
  await initSettings();
  render(() => <App me={me.me} />, root);
}
